'use client';

import { Stack } from '@chakra-ui/react';

import type { RegistrationFormModel } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const RegistrationForm = () => {
	return (
		<Stack gap="lg">
			<Form.TextInput<RegistrationFormModel> label="First Name" name="firstName" size="lg" />
			<Form.TextInput<RegistrationFormModel> label="Last Name" name="lastName" size="lg" />
			<Form.TextInput<RegistrationFormModel> label="Email" name="email" size="lg" />
			<Form.PasswordInput<RegistrationFormModel> label="Password" name="password" size="lg" />
		</Stack>
	);
};
